// src/components/TransitionCard.tsx
import React, { useMemo, memo } from 'react'; // <<< CHANGED: Imported useMemo
import { easeCubicInOut } from 'd3-ease';

interface TransitionCardProps {
  text: string;
  isVisible: boolean;
  endYPosition: number;
  exitStyle?: 'fade' | 'scrollOff';
  progress?: number;
}

const MOVEMENT_PHASE_END_PROGRESS = 0.7;

// --- Style constants (Desktop values) ---
const DESKTOP_CARD_WIDTH = 380; // <<< RENAMED
const CARD_HEIGHT = 60;
const FONT_STYLE = '500 34px "Inter", sans-serif';
const TEXT_COLOR = "#1A1A1A";
const BOX_COLOR = "rgba(255, 255, 255, 0.58)";
const CORNER_RADIUS = 4;


const TransitionCard: React.FC<TransitionCardProps> = ({ text, isVisible, endYPosition, exitStyle, progress }) => {
  // <<< START: DYNAMIC SIZING LOGIC >>>
  const cardWidth = useMemo(() => {
    const isMobile = window.innerWidth < 768;
    return isMobile ? window.innerWidth * 0.9 : DESKTOP_CARD_WIDTH;
  }, []); // This will re-calculate if the component re-renders due to a resize
  // <<< END: DYNAMIC SIZING LOGIC >>>

  if (!isVisible) {
    return null;
  }

  // --- Animation Logic (no changes here) ---
  const currentExitStyle = exitStyle || 'fade';
  let currentY: number;
  let opacity: number;

  if (currentExitStyle === 'scrollOff') {
    opacity = 1.0;
    const startY = -CARD_HEIGHT;
    const endScrollY = window.innerHeight;
    currentY = startY + (endScrollY - startY) * easeCubicInOut(progress || 0);
  } else {
    const startY = -CARD_HEIGHT;
    const endY = endYPosition;
    const currentProgress = progress || 0;

    if (currentProgress <= MOVEMENT_PHASE_END_PROGRESS) {
        opacity = 1.0;
        const movementProgress = currentProgress / MOVEMENT_PHASE_END_PROGRESS;
        const easedMovementProgress = easeCubicInOut(movementProgress);
        currentY = startY + (endY - startY) * easedMovementProgress;
    } else {
        currentY = endY;
        const fadeProgress = (currentProgress - MOVEMENT_PHASE_END_PROGRESS) / (1 - MOVEMENT_PHASE_END_PROGRESS);
        opacity = 1 - fadeProgress;
    }
  }

  opacity = Math.max(0, Math.min(1, opacity));

  // --- CSS Styles ---
  const cardStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: '50%',
    width: `${cardWidth}px`, // <<< CHANGED: Using dynamic cardWidth
    height: `${CARD_HEIGHT}px`,
    backgroundColor: BOX_COLOR,
    borderRadius: `${CORNER_RADIUS}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: FONT_STYLE,
    color: TEXT_COLOR,
    zIndex: 100,
    pointerEvents: 'none',
    opacity: opacity,
    transform: `translate(-50%, ${currentY}px)`,
    visibility: opacity > 0 ? 'visible' : 'hidden',
  };

  return (
    <div style={cardStyle}>
      {text}
    </div>
  );
};

export default memo (TransitionCard);